import { InjectionToken } from '@angular/core';

export interface IconDef {
    viewBox: string;
    content: string;
    /** If true, the icon uses stroke instead of fill */
    strokeBased?: boolean;
}

export const ICON_REGISTRY: Record<string, IconDef> = {
    'arrow-back-filled': {
        viewBox: '0 0 24 24',
        content: '<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>',
    },
    'warning-amber': {
        viewBox: '0 0 18 18',
        content:
            '<path d="M9 4.4925L14.6475 14.25H3.3525L9 4.4925ZM9 1.5L0.75 15.75H17.25L9 1.5Z" fill="#ED6C02"/>' +
            '<path d="M9.75 12H8.25V13.5H9.75V12Z" fill="#ED6C02"/>' +
            '<path d="M9.75 7.5H8.25V11.25H9.75V7.5Z" fill="#ED6C02"/>',
    },
    folder: {
        viewBox: '0 0 24 24',
        content: '<path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>',
    },
    'folder-open': {
        viewBox: '0 0 24 24',
        content: '<path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>',
    },
    crosshair: {
        viewBox: '0 0 24 24',
        content:
            '<circle cx="12" cy="12" r="8"/>' +
            '<circle cx="12" cy="12" r="2.5"/>' +
            '<line x1="12" y1="1" x2="12" y2="5"/>' +
            '<line x1="12" y1="19" x2="12" y2="23"/>' +
            '<line x1="1" y1="12" x2="5" y2="12"/>' +
            '<line x1="19" y1="12" x2="23" y2="12"/>',
        strokeBased: true,
    },
    trash: {
        viewBox: '0 0 24 24',
        content: '<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>',
    },
    pencil: {
        viewBox: '0 0 24 24',
        content: '<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>',
    },
    download: {
        viewBox: '0 0 24 24',
        content: '<path d="M12 16l-5-5h3V4h4v7h3l-5 5zM5 18h14v2H5z"/>',
    },
    link: {
        viewBox: '0 0 24 24',
        content: '<path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>',
    },
    unlink: {
        viewBox: '-3 -3 30 30',
        content:
            '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H4a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"/>' +
            '<line x1="8" y1="12" x2="16" y2="12"/>' +
            '<line x1="3" y1="3" x2="21" y2="21"/>',
        strokeBased: true,
    },
    'drag-handle': {
        viewBox: '0 0 24 24',
        content: '<path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
    },
    'list-view': {
        viewBox: '0 0 24 24',
        content: '<path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>',
    },
    'grid-view': {
        viewBox: '0 0 24 24',
        content: '<rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="8" rx="1.5"/><rect x="3" y="13" width="8" height="8" rx="1.5"/><rect x="13" y="13" width="8" height="8" rx="1.5"/>',
    },
    eye: {
        viewBox: '0 0 24 24',
        content: '<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>',
    },
    upload: {
        viewBox: '0 0 24 24',
        content: '<path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z"/>',
    },
    'more-dots': {
        viewBox: '0 0 24 24',
        content: '<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
    },
    pdf: {
        viewBox: '0 0 24 24',
        content: '<path d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 9.5C11.5 10.33 10.83 11 10 11H9V13H7.5V7H10C10.83 7 11.5 7.67 11.5 8.5V9.5ZM16.5 11.5C16.5 12.33 15.83 13 15 13H12.5V7H15C15.83 7 16.5 7.67 16.5 8.5V11.5ZM20.5 8.5H19V9.5H20.5V11H19V13H17.5V7H20.5V8.5ZM9 9.5H10V8.5H9V9.5ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM14 11.5H15V8.5H14V11.5Z" fill="#D32F2F"/>',
    },
    'file-image': {
        viewBox: '0 0 24 24',
        content: '<path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" fill="#43A047"/>',
    },
    'file-word': {
        viewBox: '0 0 24 24',
        content: '<path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM15.2 17h-1.4l-1.8-5-1.8 5H8.8L6.6 9h1.5l1.4 5 1.8-5h1.4l1.8 5 1.4-5H17l-1.8 8zM13 9V3.5L18.5 9H13z" fill="#1565C0"/>',
    },
    'file-excel': {
        viewBox: '0 0 24 24',
        content: '<path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM15.4 17H13l-1-2.8L10.9 17H8.6l2-3.5-1.8-3.5h2.3l.9 2.5.9-2.5h2.3l-1.8 3.4 2 3.6zM13 9V3.5L18.5 9H13z" fill="#2E7D32"/>',
    },
    'file-powerpoint': {
        viewBox: '0 0 24 24',
        content: '<path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM9.5 17V10h3c1.38 0 2.5 1.12 2.5 2.5S13.88 15 12.5 15H11v2H9.5zM13 9V3.5L18.5 9H13z" fill="#D84315"/><path d="M11 12v1.5h1.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H11z" fill="#D84315"/>',
    },
    'file-video': {
        viewBox: '0 0 24 24',
        content: '<path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" fill="#7B1FA2"/>',
    },
    'file-audio': {
        viewBox: '0 0 24 24',
        content: '<path d="M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z" fill="#F57C00"/>',
    },
    'file-archive': {
        viewBox: '0 0 24 24',
        content: '<path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2z" fill="#78909C"/>',
    },
    'file-text': {
        viewBox: '0 0 24 24',
        content: '<path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 14H8v-2h8v2zm0-4H8v-2h8v2zM13 9V3.5L18.5 9H13z" fill="#546E7A"/>',
    },
    'file-generic': {
        viewBox: '0 0 24 24',
        content: '<path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13z" fill="#90A4AE"/>',
    },
    'link-matrix': {
        viewBox: '0 0 48 36',
        content:
            '<path d="M13.05 26L15.05 26L15.05 10L13.05 10L13.05 26Z"/>' +
            '<path d="M32.95 26L34.95 26L34.95 10L32.95 10L32.95 26Z"/>' +
            '<path d="M32.0156 18.0498L27.5156 22.5498L26.0654 21.0996L28.165 19H19.958L22.0576 21.0996L20.6074 22.5498L16.1074 18.0498L20.6074 13.5498L22.0576 15L20.0576 17H28.0654L26.0654 15L27.5156 13.5498L32.0156 18.0498Z"/>',
    },
};

export type IconName = keyof typeof ICON_REGISTRY;

export const ICON_REGISTRY_TOKEN = new InjectionToken<Record<string, IconDef>>(
    'ICON_REGISTRY',
    { providedIn: 'root', factory: () => ({ ...ICON_REGISTRY }) },
);
